module.exports = __webpack_public_path__ + "img/tech-children-how-to-think.b957e6e.jpg";